export default {
    init() {
        const className = 'faq_accordion__item';
        const items = document.querySelectorAll('.' + className);

        function activeTab(){
            this.classList.toggle(className + '--active');
        }

        items.forEach(item => {
            item.addEventListener('click', activeTab)
        })
    },
}


// WEBPACK FOOTER //
// ./scripts/components/faq-accordion.js